/*
 * useAddPanel.tsx - Add an Entity
 *
 * Created by Dr. Maximillian Dornseif 2021-09
 * Copyright (c) 2021, 2023 HUDORA GmbH
 */

import { PrimaryButton } from '@fluentui/react/lib/Button'
import { ICommandBarItemProps } from '@fluentui/react/lib/CommandBar'
import get from 'lodash.get'
import set from 'lodash.set'
import React, { ReactElement } from 'react'

import { IEntity } from '../../types'
import { EntityCreate } from '../components/EntityMutate'
import { IKindListeProps } from '../components/KindListe'
import { MuiPanel, usePanelMui } from './usePanel'

/** Panel zum Zufügen von Entities.
 *
 * Dabei wird `createPreset` genutzt, um mit `data` die Vorbelegung auszufüllen.
 *
 * @deprecated
 * */
export function useAddPanel(
  options: IKindListeProps
): [ICommandBarItemProps, ReactElement, ReactElement, () => void] {
  const mutation = options.createMutation
  const [openPanel, panelProps, isPanelOpen, dismissPanel] = usePanelMui('Neuen Datensatz anlegen')

  if (!mutation) {
    return [null, null, null, null]
  }

  const commandBarItem: ICommandBarItemProps = {
    key: 'add',
    text: 'Datensatz zufügen',
    title: 'Neuen Datensatz anlegen',
    ariaLabel: 'Datensatz zufügen',
    iconProps: { iconName: 'Add' },
    iconOnly: false,
    onClick: openPanel,
  }
  const mutateButton = mutation ? (
    <PrimaryButton
      text="Datensatz zufügen"
      title="Neuen Datensatz anlegen"
      ariaLabel="Zufügen"
      iconProps={{ iconName: 'Add' }}
      onClick={openPanel}
    />
  ) : null

  const newEntity: Partial<IEntity> = options.createTemplate || {}
  for (const k of Object.keys(options.createPreset || {})) {
    // support object.property dot notation
    set(newEntity, k, get({ entity: options.entity }, options.createPreset[k]))
  }

  const thePanel = isPanelOpen ? (
    <MuiPanel {...panelProps} onDismiss={dismissPanel}>
      <EntityCreate
        forDesignator={options.nr}
        isOpen={true}
        entity={newEntity}
        schemaName={options.schemaName}
        mutation={mutation}
        listQuery={options.listQuery}
        listQueryOptions={options.listQueryOptions}
      />
    </MuiPanel>
  ) : null

  return [commandBarItem, thePanel, mutateButton, openPanel]
}
